import React, { Component } from 'react';

import { withAppStepsState } from "../../../shared/containers/containerAppStepsState"
import { withClearStepsData } from "../../../shared/containers/containerClearStepsData"
import { withResultPageState } from "../../../shared/containers/containerResultPageState"

import HeaderAppSteps from "./headerAppSteps"

import Sex from "./../sex/sex"
import FirstPageQuestionA from "./../firstPageQuestionA/firstPageQuestionA"
import FirstPageQuestionB from "./../firstPageQuestionB/firstPageQuestionB"
import FirstPageQuestionC from "../firstPageQuestionC/firstPageQuestionC"
import FirstPageQuestionD from "../firstPageQuestionD/firstPageQuestionD"
import Result from "./../result/result"
import CurrentActivity from "./../currentActivity/currentActivity"
import Name from "./../name/name"
import Mail from "./../mail/mail"
import Old from "./../old/old"
import Height from "./../height/height"
import CurrentWeight from "../currentWeight/currentWeight"
import GoalWeight from "../goalWeight/goalWeight"
import DietType from "../dietType/dietType"
import BodyZone from "../bodyZone/bodyZone"
import FitnesLevel from "../fitnesLevel/fitnesLevel"
import Help from "../help/help"
import WorkHard from "../workHard/workHard"
import WorkTime from "../workTime/workTime"
import Sleep from "../sleep/sleep"
import Water from "../water/water"
import Motivation from "../motivation/motivation"
import LifeChange from "../lifeChange/lifeChange"
import IdealWeight from "../idealWeight/idealWeight"

import Loader from "../loader/loader"
import ResultPage from "../resultPage/resultPage"

import getParameterFromURL from "../../../utils/getParameterFromUrl"

import variables from "./../../../assets/styles/values.scss"
import styles from "./stepsWrapper.module.scss"
import store from './../../../store'

let firstQuestionA = (getParameterFromURL("firstQuestionA") === "true");
let firstQuestionB = (getParameterFromURL("firstQuestionB") === "true");
let firstQuestionC = (getParameterFromURL("firstQuestionC") === "true");
let firstQuestionD = (getParameterFromURL("firstQuestionD") === "true");
class AppStepsWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: true,
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { isOpenAppSteps, onClearData } = this.props
    const { isOpen } = this.state

    if (prevProps.isOpenAppSteps && !isOpenAppSteps)
      setTimeout(function () {
        this.setState({ isOpen: true })
      }.bind(this), variables.animateSteps)

    if (!prevProps.isOpenAppSteps && isOpenAppSteps)
      this.setState({ isOpen: true })

    if (prevState.isOpen && !isOpen)
      onClearData()
  }

  render() {
    let isAgeAbtest = store.getState().appState.isAgeAbtest;
    let isExtraSteps = store.getState().appState.isExtraSteps;
    let forGender = store.getState().appState.forGender;
    let isWithMail = store.getState().appState.isWithMail;
    let isAgeManTest = store.getState().appState.isAgeManTest;
    let isAgeTest = isAgeAbtest || isAgeManTest;

    const { onOpenApp, isOpenAppSteps, openResultPage } = this.props
    const wrapperClassName = true
      ? openResultPage 
        ? styles.appStepsWrapperFinished
        : styles.appStepsWrapper
      : styles.appStepsWrapperHidden

    if (isExtraSteps && this.state.isOpen) {
      return (
        <div className={wrapperClassName}>
          {
            !openResultPage
              ? <div className={styles.container_herader}>
                <HeaderAppSteps />
              </div>
              : null
          }
          {forGender === 'female' && 
          <div className={styles.container_stepContent}>
              {firstQuestionA && <FirstPageQuestionA/>}
              {firstQuestionB && <FirstPageQuestionB/>}
              {firstQuestionC && <FirstPageQuestionC/>}
              {firstQuestionD && <FirstPageQuestionD/>}
              <Old />
              <Result />
              <CurrentActivity />
              <Name />
              <Height />
              <CurrentWeight />
              <GoalWeight />
              <DietType />
              <BodyZone />
              <FitnesLevel />
              <Help />
              <WorkHard />
              <WorkTime />
              <Sleep />
              <Water />
              <Motivation />
              <LifeChange />
              <IdealWeight />
              {isWithMail && <Mail />}
          </div>
          }
          {forGender === 'male' && 
          <div className={styles.container_stepContent}>
              {firstQuestionA && <FirstPageQuestionA/>}
              {firstQuestionB && <FirstPageQuestionB/>}
              {firstQuestionC && <FirstPageQuestionC/>}
              {firstQuestionD && <FirstPageQuestionD/>}
              <Sex />
              <Result />
              <CurrentActivity />
              <Name />
              <Old />
              <Height />
              <CurrentWeight />
              <GoalWeight />
              <DietType />
              <BodyZone />
              <FitnesLevel />
              <Help />
              <WorkHard />
              <WorkTime />
              <Sleep />
              <Water />
              <Motivation />
              <LifeChange />
              <IdealWeight />
              {isWithMail && <Mail />}
          </div>
          }
          <Loader />
          <ResultPage />
        </div>
      )
    }

    return this.state.isOpen
      ?
      <div className={wrapperClassName}>

        {
          !openResultPage
            ? <div className={styles.container_header}>
              <HeaderAppSteps />
            </div>
            : null
        }
        {
          !openResultPage && !firstQuestionA && !firstQuestionB && !firstQuestionC && !firstQuestionD && isAgeTest
            ? <div className={styles.container_stepContent}>
                <Old />
                <Result />
                <CurrentActivity />
                <Name />
                <Height />
                <CurrentWeight />
                <GoalWeight />
                <DietType />
                <BodyZone />
                <FitnesLevel />
                <Help />
                <WorkHard />
                {isWithMail && <Mail />}
                <WorkTime />
              </div>
            : null
        }

        {
          !openResultPage && !firstQuestionA && !firstQuestionB && !firstQuestionC && !firstQuestionD && !isAgeTest
            ? <div className={styles.container_stepContent}>
                <Sex />
                <Result />
                <CurrentActivity />
                <Name />
                <Old />
                <Height />
                <CurrentWeight />
                <GoalWeight />
                <DietType />
                <BodyZone />
                <FitnesLevel />
                <Help />
                <WorkHard />
                {isWithMail && <Mail />}
                <WorkTime />
              </div>
            : null
        }

        {
          !openResultPage && firstQuestionA
            ?<div className={styles.container_stepContent}>
              <FirstPageQuestionA/>
              <Result />
              <CurrentActivity />
              <Name />
              <Old />
              <Height />
              <CurrentWeight />
              <GoalWeight />
              <DietType />
              <BodyZone />
              <FitnesLevel />
              <Help />
              <WorkHard />
              {isWithMail && <Mail />}
              <WorkTime />
            </div>
            : null
        }

        {
          !openResultPage && firstQuestionB
            ?<div className={styles.container_stepContent}>
              <FirstPageQuestionB/>
              <CurrentActivity />
              <Old />
              <Height />
              <CurrentWeight />
              <GoalWeight />
              <DietType />
              <FitnesLevel />
              <BodyZone />
              <Help />
              <WorkHard />
              <WorkTime />
              {isWithMail && <Mail />}
            </div>
            : null
        }

        {
          !openResultPage && firstQuestionC
            ?<div className={styles.container_stepContent}>
              <FirstPageQuestionC/>
              <Result />
              <Old />
              <CurrentActivity />
              <Name />
              <Height />
              <CurrentWeight />
              <GoalWeight />
              <DietType />
              <BodyZone />
              <FitnesLevel />
              <Help />
              <Sex />
              <WorkHard />
              <Mail />
              <WorkTime />
            </div>
            : null
        }

        {
          !openResultPage && firstQuestionD
            ?<div className={styles.container_stepContent}>
              <FirstPageQuestionD/>
              <Sex />
              <Result />
              <Old />
              <CurrentActivity />
              <Name />
              <Height />
              <CurrentWeight />
              <GoalWeight />
              <DietType />
              <BodyZone />
              <FitnesLevel />
              <Help />
              <WorkHard />
              <Mail />
              <WorkTime />
            </div>
            : null
        }

        <Loader />

        <ResultPage />

      </div >
      : null
  }
}

export default withAppStepsState(withClearStepsData(withResultPageState(AppStepsWrapper)))